/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {AntennaInstance} from "../models/antenna-instance";
import {AntennaService} from "../services/antenna.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class AntennaInstancesPagingResolver implements Resolve<PagedResults<AntennaInstance>> {

  constructor(
    private mAntennaService: AntennaService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<AntennaInstance>> {
    try {
      return await this.mAntennaService.getAllAntennaInstancesForPaging(0, PAGING_ITEMS_PER_PAGE, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Antenna Instances... Error: " + error, error);
    }
  }

}
